var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import { useTypeDispatch } from '../../hooks/useTypeDispatch';
import { LangSlice } from '../../redux/reducers/LangSlice';
import { useTypeSelector } from '../../hooks/useTypeSelector';
import { useLocation, useNavigate } from 'react-router-dom';
import { url } from '../../config/url';
import { matchRoute } from './pageTitle';
import { Avatar } from '../../img';
import { request } from '../../config/request';
import { id_role_dekanat, id_role_student } from '../../config/roles';
import ModalSet from '../../ui/SearchStudent/ModalSet/ModalSet';
const LANGS = [
    { code: 'ru', short: 'Рус', label: 'Русский' },
    { code: 'kg', short: 'Кыр', label: 'Кыргызча' },
    { code: 'en', short: 'Eng', label: 'English' }
];
const currentTheme = () => document.documentElement.getAttribute('data-theme') ||
    (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
const TABS_STORE = 'vm.tabs';
/**
 * Вкладки предыдущего входа — только если вошёл тот же человек.
 *
 * Храним вместе с номером пользователя. При выходе Header размонтируется
 * вместе со всей шапкой, и почистить список изнутри он уже не успевает —
 * поэтому чужие вкладки отсеиваем при чтении, а не при выходе. Иначе
 * преподаватель, сменившийся в том же окне на студента, получал бы в
 * шапке вкладки чужих разделов, а по нажатию — «страница не найдена».
 */
const readTabs = (user) => {
    var _a;
    try {
        const raw = sessionStorage.getItem(TABS_STORE);
        if (!raw)
            return [];
        const saved = JSON.parse(raw);
        if (!saved || String((_a = saved.user) !== null && _a !== void 0 ? _a : '') !== String(user !== null && user !== void 0 ? user : ''))
            return [];
        const list = Array.isArray(saved.tabs) ? saved.tabs : [];
        return list.filter((t) => {
            var _a;
            return t &&
                typeof t.path === 'string' &&
                typeof t.key === 'string' &&
                /* Путь должен быть корнем своего раздела. Отсеиваем то, что
                   осело в памяти окна от прежней таблицы разделов: страница
                   дня одно время заводила собственную вкладку, и в шапке
                   висели две «Сегодня» подряд. */
                ((_a = matchRoute(t.path)) === null || _a === void 0 ? void 0 : _a.route) === t.path;
        });
    }
    catch (e) {
        return [];
    }
};
const Header = ({ changeMenu, isNavigation, logout }) => {
    var _a;
    const { surname, name } = useTypeSelector(state => state.userInfoReducer);
    const { id_user, id_avn_user, id_role, isAuth } = useTypeSelector(state => state.authReducer);
    const dispatch = useTypeDispatch();
    const { changeLang } = LangSlice.actions;
    const { i18n, t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [photo, setPhoto] = useState('');
    const [theme, setTheme] = useState(currentTheme);
    const [langOpen, setLangOpen] = useState(false);
    const langRef = useRef(null);
    /* Выход спрятан в карточке пользователя: место для него там, где
       написано, кто вошёл, — а не отдельной кнопкой внизу меню, куда
       попадают мимо, промахнувшись по последнему разделу. */
    const [userOpen, setUserOpen] = useState(false);
    const userRef = useRef(null);
    /**
     * Настройки журнала — там же, в карточке пользователя.
     *
     * Показываем тем, у кого есть AVN 20 (администрирование пользователей
     * подсистем AVN): настройки журнала правят те же люди. Прежнее право
     * из вкладок деканата тоже принимаем — иначе те, кто пользовался
     * ссылкой раньше, её бы лишились.
     *
     * Раньше ссылка жила внизу страницы «Поиск студентов»: чтобы открыть
     * настройки, нужно было сначала попасть в деканатский раздел и
     * пролистать список студентов до конца.
     */
    const [avn20, setAvn20] = useState(false);
    const [setsOpen, setSetsOpen] = useState(false);
    const { controlPerm } = useTypeSelector(state => state.controlPermReducer);
    const canSettings = avn20 || Number((_a = controlPerm === null || controlPerm === void 0 ? void 0 : controlPerm[0]) === null || _a === void 0 ? void 0 : _a.setings) === 1;
    /**
     * Открытые страницы — полосой вкладок слева, как в AVNSchedule.
     *
     * Раньше здесь была одна плашка с названием текущего раздела. Журнал
     * заставляет ходить между разделами кругами: тема урока на одной
     * странице, задания на другой, план на третьей, — и каждый возврат
     * терял выбранные фильтры. Вкладки держат уже открытое под рукой.
     *
     * Живут в sessionStorage: перезагрузка страницы набор не теряет, а
     * закрытие окна — теряет, и это правильно, чужой список вкладок
     * следующему дню не нужен.
     */
    const [tabs, setTabs] = useState(() => readTabs(id_user));
    /** Раздел текущего адреса. Вход и проверка токена вкладкой не становятся. */
    const here = matchRoute(location.pathname);
    useEffect(() => {
        if (!here)
            return;
        setTabs(prev => (prev.some(x => x.path === here.route) ? prev : [...prev, { path: here.route, key: here.key }]));
    }, [here === null || here === void 0 ? void 0 : here.route]);
    useEffect(() => {
        try {
            sessionStorage.setItem(TABS_STORE, JSON.stringify({ user: id_user, tabs }));
        }
        catch (e) { }
    }, [tabs, id_user]);
    /* После выхода список чужой — сбрасываем вместе с авторизацией. */
    useEffect(() => {
        if (!isAuth)
            setTabs([]);
    }, [isAuth]);
    /**
     * Закрыть вкладку.
     *
     * Уходим на соседнюю слева, а не на первую: закрывают обычно то, куда
     * заглянули мимоходом, и вернуться надо туда, откуда пришли. Последнюю
     * вкладку закрыть нельзя — пустая полоса выглядит как поломка.
     */
    const closeTab = (e, path) => {
        e.stopPropagation();
        if (tabs.length < 2)
            return;
        const i = tabs.findIndex(x => x.path === path);
        const next = tabs.filter(x => x.path !== path);
        setTabs(next);
        if (path === (here === null || here === void 0 ? void 0 : here.route))
            navigate(next[Math.max(0, i - 1)].path);
    };
    /**
     * Перетаскивание вкладок.
     *
     * Порядок человек выстраивает под свою работу: журнал и темы рядом,
     * редкое — в конец полосы. Отдельной кнопки «сохранить» здесь быть не
     * должно: новый порядок уходит в то же хранилище, что и сам набор
     * вкладок, тем же обработчиком, что и открытие с закрытием.
     *
     * Меняем местами прямо во время перетаскивания, а не по отпусканию:
     * иначе не видно, куда вкладка встанет. Порог — середина соседней
     * вкладки, а не её край: подписи разной длины, и от касания края
     * узкая вкладка прыгала бы туда-сюда под курсором.
     */
    const [dragPath, setDragPath] = useState(null);
    /** Где вкладка стоит сейчас: по ходу перетаскивания индекс меняется. */
    const dragAt = useRef(null);
    /** Порядок поменялся — значит, это перетаскивание, а не промах по вкладке. */
    const dragMoved = useRef(false);
    /** Вкладка, которой вернуть фокус после перестановки с клавиатуры. */
    const keepFocus = useRef(null);
    /**
     * Автопрокрутка полосы у края.
     *
     * Вкладок бывает больше, чем помещается, и полоса прокручивается
     * вбок. Без подкрутки вкладку не утащить за видимый край: курсор
     * упирается в границу, а лента стоит на месте.
     *
     * Останавливаем не по «курсор ушёл с полосы»: это событие приходит
     * и при переходе с вкладки на вкладку внутри неё, и лента замирала
     * бы на каждой. Считаем по времени: пока тащат над краем, браузер
     * шлёт dragover не реже чем раз в треть секунды, а замолчал он —
     * значит, увели в сторону или бросили.
     */
    const stripRef = useRef(null);
    /** Пикселей за кадр; знак — сторона. Ноль — стоим. */
    const scrollStep = useRef(0);
    const scrollFrame = useRef(0);
    const lastOver = useRef(0);
    const stopScroll = () => {
        scrollStep.current = 0;
        if (scrollFrame.current)
            cancelAnimationFrame(scrollFrame.current);
        scrollFrame.current = 0;
    };
    const scrollTick = () => {
        const strip = stripRef.current;
        if (!strip || !scrollStep.current || Date.now() - lastOver.current > 400)
            return stopScroll();
        strip.scrollLeft += scrollStep.current;
        scrollFrame.current = requestAnimationFrame(scrollTick);
    };
    /** Курсор у края полосы — подкручиваем ленту под ним. */
    const edgeScroll = (e) => {
        const strip = stripRef.current;
        if (!strip || dragAt.current === null)
            return;
        e.preventDefault();
        /* Уже — не поймать курсором, шире — мешает положить вкладку
           крайней: у самого края лента едет, а не ждёт. */
        const ZONE = 48;
        const box = strip.getBoundingClientRect();
        const toLeft = e.clientX - box.left;
        const toRight = box.right - e.clientX;
        /* Чем ближе к краю, тем быстрее: так и дальний конец догоняешь,
           и у границы зоны лента ползёт, а не прыгает. */
        const speed = (d) => Math.min(16, Math.max(2, Math.ceil(((ZONE - d) / ZONE) * 16)));
        scrollStep.current = toLeft < ZONE ? -speed(toLeft) : toRight < ZONE ? speed(toRight) : 0;
        lastOver.current = Date.now();
        if (scrollStep.current && !scrollFrame.current)
            scrollFrame.current = requestAnimationFrame(scrollTick);
    };
    /* Кадр, заказанный на перетаскивание, переживёт уход со страницы. */
    useEffect(() => stopScroll, []);
    const dragStart = (e, i, path) => {
        dragAt.current = i;
        dragMoved.current = false;
        setDragPath(path);
        e.dataTransfer.effectAllowed = 'move';
        /* Firefox не начинает перетаскивание, пока в обмене пусто. */
        e.dataTransfer.setData('text/plain', path);
    };
    const dragOver = (e, i) => {
        /* Без этого браузер считает вкладку неподходящим местом и по
           отпусканию рисует «отказ». */
        e.preventDefault();
        e.dataTransfer.dropEffect = 'move';
        const from = dragAt.current;
        if (from === null || from === i)
            return;
        const box = e.currentTarget.getBoundingClientRect();
        const mid = box.left + box.width / 2;
        if (i > from ? e.clientX < mid : e.clientX > mid)
            return;
        dragAt.current = i;
        dragMoved.current = true;
        setTabs(prev => {
            const next = prev.slice();
            next.splice(i, 0, next.splice(from, 1)[0]);
            return next;
        });
    };
    const dragEnd = () => {
        dragAt.current = null;
        setDragPath(null);
        stopScroll();
    };
    /**
     * Переход по вкладке.
     *
     * После перетаскивания часть браузеров присылает ещё и клик. Уводить
     * по нему на другую страницу нельзя: человек вкладку двигал, а не
     * открывал. Признак гасим на нажатии — следующий клик снова обычный.
     */
    const clickTab = (path) => {
        if (!dragMoved.current)
            navigate(path);
    };
    /**
     * Перестановка с клавиатуры.
     *
     * Мышью переставит не каждый: мышь бывает без кнопки перетаскивания,
     * а бывает, что человек за клавиатурой и не отрывается от неё.
     *
     * Ctrl со стрелкой. Alt со стрелкой занят браузером под «назад» и
     * «вперёд», а стрелка без модификатора должна оставаться за самой
     * страницей — на полосе вкладок фокус всё равно переставляют Tab-ом.
     */
    const moveTab = (e, i) => {
        if (!e.ctrlKey || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight'))
            return;
        const to = i + (e.key === 'ArrowLeft' ? -1 : 1);
        if (to < 0 || to >= tabs.length)
            return;
        e.preventDefault();
        keepFocus.current = tabs[i].path;
        setTabs(prev => {
            const next = prev.slice();
            next.splice(to, 0, next.splice(i, 1)[0]);
            return next;
        });
    };
    /**
     * Фокус остаётся на переставленной вкладке.
     *
     * Переставляя, React переносит саму кнопку в другое место полосы, а
     * при переносе узла браузер снимает с него фокус. Без возврата
     * вторая стрелка подряд уже никуда не попадала бы. Заодно .focus()
     * сам подкручивает ленту, если вкладка уехала за край.
     */
    useEffect(() => {
        var _a, _b;
        const path = keepFocus.current;
        if (!path)
            return;
        keepFocus.current = null;
        (_b = (_a = stripRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[data-tab="${path}"]`)) === null || _b === void 0 ? void 0 : _b.focus();
    }, [tabs]);
    const roleName = () => id_role == id_role_dekanat ? 'Деканат' : id_role == id_role_student ? 'Студент' : 'Преподаватель';
    const lang = LANGS.find(l => l.code === i18n.language) || LANGS[0];
    const setLang = (code) => {
        i18n.changeLanguage(code);
        dispatch(changeLang(code === 'kg' ? 2 : code === 'en' ? 3 : 1));
        try {
            localStorage.setItem('lang', code);
        }
        catch (e) { }
        setLangOpen(false);
    };
    const toggleTheme = () => {
        const next = currentTheme() === 'dark' ? 'light' : 'dark';
        document.documentElement.setAttribute('data-theme', next);
        setTheme(next);
        try {
            localStorage.setItem('vm.theme', next);
        }
        catch (e) { }
    };
    const getPhoto = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c;
        try {
            const { data } = yield request(`/teacher/photo?id_role=${id_role}&id_user=${id_user}`, 'POST');
            const photoData = (_c = (_b = data === null || data === void 0 ? void 0 : data[0]) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.photo;
            if (photoData) {
                const b64 = btoa(new Uint8Array(photoData.data).reduce((acc, byte) => acc + String.fromCharCode(byte), ''));
                setPhoto(`data:image/jpeg;base64,${b64}`);
            }
            else
                setPhoto('');
        }
        catch (err) {
            setPhoto('');
        }
    });
    useEffect(() => {
        if (isAuth)
            getPhoto();
    }, [id_role, id_user, isAuth]);
    /* Право на AVN 20 спрашиваем один раз за вход: оно не меняется, пока
       человек работает, а ошибку запроса считаем отсутствием права. */
    useEffect(() => {
        if (!isAuth || !id_avn_user)
            return;
        const ask = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const { data } = yield request(`/dekanat/avn20`, 'GET');
                setAvn20(Number(data === null || data === void 0 ? void 0 : data.perm) === 1);
            }
            catch (e) {
                setAvn20(false);
            }
        });
        ask();
    }, [isAuth, id_avn_user]);
    /** Закрываем список языков по клику мимо него. */
    useEffect(() => {
        if (!langOpen)
            return;
        const away = (e) => {
            if (langRef.current && !langRef.current.contains(e.target))
                setLangOpen(false);
        };
        document.addEventListener('mousedown', away);
        return () => document.removeEventListener('mousedown', away);
    }, [langOpen]);
    /** То же для карточки пользователя. */
    useEffect(() => {
        if (!userOpen)
            return;
        const away = (e) => {
            if (userRef.current && !userRef.current.contains(e.target))
                setUserOpen(false);
        };
        document.addEventListener('mousedown', away);
        return () => document.removeEventListener('mousedown', away);
    }, [userOpen]);
    return (_jsxs("header", Object.assign({ className: styles.bar }, { children: [_jsx("button", Object.assign({ type: "button", className: styles.burger, onClick: changeMenu.bind(null, !isNavigation), "aria-label": "\u041C\u0435\u043D\u044E" }, { children: _jsx("i", { className: "fa-solid fa-bars" }) })), _jsx("div", Object.assign({ ref: stripRef, className: styles.tabs, onDragOver: edgeScroll, onDrop: e => e.preventDefault() }, { children: tabs.map((tab, i) => (_jsxs("button", Object.assign({ type: "button", draggable: true, "data-tab": tab.path, "aria-keyshortcuts": "Control+ArrowLeft Control+ArrowRight", className: `${styles.tab} ${tab.path === (here === null || here === void 0 ? void 0 : here.route) ? styles.tabOn : ''}` +
                        `${tab.path === dragPath ? ' ' + styles.tabDrag : ''}`, onMouseDown: () => {
                        dragMoved.current = false;
                    }, onDragStart: e => dragStart(e, i, tab.path), onDragOver: e => dragOver(e, i), onDrop: e => e.preventDefault(), onDragEnd: dragEnd, onClick: () => clickTab(tab.path), onKeyDown: e => moveTab(e, i), title: String(t(tab.key)) }, { children: [_jsx("span", Object.assign({ className: styles.tabName }, { children: t(tab.key) })), tabs.length > 1 && (_jsx("i", { className: `fa-solid fa-xmark ${styles.tabX}`, onClick: e => closeTab(e, tab.path), title: String(t('close')) }))] }), tab.path))) })), _jsx("div", { className: styles.spacer }), _jsx("a", Object.assign({ className: styles.icon, href: `${url}/doc/manual_${id_role == id_role_student ? 'student' : 'teacher'}.html`, target: "_blank", rel: "noreferrer", title: t('instruction') }, { children: _jsx("i", { className: "fa-solid fa-circle-question" }) })), _jsx("button", Object.assign({ type: "button", className: styles.icon, onClick: toggleTheme, title: theme === 'dark' ? 'Дневной режим' : 'Тёмный режим', "aria-label": "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0442\u0435\u043C\u0443" }, { children: _jsx("i", { className: `fa-solid ${theme === 'dark' ? 'fa-sun' : 'fa-moon'}` }) })), _jsxs("div", Object.assign({ className: styles.lang, ref: langRef }, { children: [_jsxs("button", Object.assign({ type: "button", className: styles.langBtn, onClick: () => setLangOpen(v => !v) }, { children: [lang.short, _jsx("i", { className: "fa-solid fa-chevron-down" })] })), langOpen && (_jsx("div", Object.assign({ className: styles.langMenu }, { children: LANGS.map(l => (_jsx("button", Object.assign({ type: "button", className: l.code === lang.code ? styles.langOn : '', onClick: setLang.bind(null, l.code) }, { children: l.label }), l.code))) })))] })), _jsxs("div", Object.assign({ className: styles.user, ref: userRef }, { children: [_jsxs("button", Object.assign({ type: "button", className: styles.userBtn, onClick: () => setUserOpen(v => !v) }, { children: [_jsx("img", { src: photo ? photo : Avatar, alt: "", className: styles.ava }), _jsxs("div", Object.assign({ className: styles.who }, { children: [_jsxs("div", Object.assign({ className: styles.fio }, { children: [surname, " ", name] })), _jsx("div", Object.assign({ className: styles.role }, { children: roleName() }))] })), _jsx("i", { className: `fa-solid fa-chevron-down ${styles.userChev}` })] })), userOpen && (_jsxs("div", Object.assign({ className: styles.userMenu }, { children: [canSettings && (_jsxs("button", Object.assign({ type: "button", className: styles.userItem, onClick: () => {
                                    setUserOpen(false);
                                    setSetsOpen(true);
                                } }, { children: [_jsx("i", { className: "fa-solid fa-gear" }), t('settings')] }))), _jsxs("button", Object.assign({ type: "button", className: styles.exit, onClick: logout }, { children: [_jsx("i", { className: "fa-solid fa-right-from-bracket" }), t('logout')] }))] })))] })), setsOpen && _jsx(ModalSet, { hideModal: () => setSetsOpen(false) })] })));
};
export default Header;
